import { TrackerFooter } from '../models/skyclub.interfaces';

export const TrackingLessThan75k: TrackerFooter = {
  total: {
    title: '$9000',
    subtitle: 'Total Spend in 2025'
  },
  max: '$75k',
  iconLink: {
    isIcon: true,
    information:
      '<p>American Express spend toward Unlimited Delta Sky Club is tracked from January 1st through December 31st. You must spend $75k to reach Unlimited Sky Club access. Access begins immediately once $75k is spent, and is valid through the end of the following Medallion year. <a href="/us/en/delta-sky-club/access" target="_blank">Terms apply.<span class="sr-only">opens in a new tab</span></a></p>',
    label: '',
    url: ''
  },
  spendLink: {
    label: 'Spend $66,000 for Unlimited Access in 2026 Medallion Year',
    url: 'https://www.delta.com/us/en/delta-sky-club/locations'
  }
};

export const Tracking75k: TrackerFooter = {
  thresholdMet: true,
  total: {
    title: '$75,000',
    subtitle: 'Total Spent in 2026'
  },
  max: '$75K',
  iconLink: {
    isIcon: true,
    information:
      '<p>American Express spend toward Unlimited Delta Sky Club is tracked from January 1st through December 31st. You must spend $75k to reach Unlimited Sky Club access. Access begins immediately once $75k is spent, and is valid through the end of the following Medallion year. <a href=\\"https://www.delta.com/resbizbenefitterms\\" target=\\"_blank\\">Terms apply.<span class=\\"sr-only\\">opens in a new tab</span></a></p>',
    label: '',
    url: ''
  },
  spendLink: {
    label: 'You have Unlimited Delta Sky Club Access',
    url: 'https://www.delta.com/us/en/delta-sky-club/locations'
  }
};
